export const formatBeneficiaryDocument = rawDocument => {
  if (rawDocument.length > 11) {
    return rawDocument.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5')
  }

  return rawDocument.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4')
}

export const formatLimitedPersonFullName = (firstName, lastName) => {
  const fullName = `${firstName} ${lastName || ''}`
  return fullName
}
